exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sign_wrap[data-v-364f824c]{width:1042px;height:750px;margin:80px auto;border:1px solid #eee;position:relative;padding:70px 50px}.start_btn[data-v-364f824c]{position:absolute;top:-52px;right:0}.intro[data-v-364f824c],.up_info[data-v-364f824c]{font-size:14px;color:#333}.intro p[data-v-364f824c],.up_info p[data-v-364f824c]{line-height:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-364f824c","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/sign/matters.vue
// module id = 365
// module chunks = 0